import Wizard, { WizardProps } from '@amzn/awsui-components-react/polaris/wizard';
import { NonCancelableEventHandler } from '@amzn/awsui-components-react/polaris/internal/events';
import { useWizardStrings } from '../../../hooks/localization/wizardStrings';
import { publishKatalMetric } from '../../katalAnalytics';

export const FIRST_PAGE = 0;

type WizardStepProps = {
  title: string;
  content: JSX.Element;
}[];

export interface CreateEventWizardProps extends Partial<WizardProps> {
  steps: WizardStepProps;
  onCancel: NonCancelableEventHandler;
  onSubmit: NonCancelableEventHandler;
  activeStepIndex: number;
}

export function CreateEventWizard(props: CreateEventWizardProps) {
  const namespaces = ['events', 'translation'];
  const wizardStrings = useWizardStrings('createEventWizard', namespaces);

  return (
    <Wizard
      i18nStrings={wizardStrings}
      {...props}
      onCancel={(input) => {
        publishKatalMetric('createEvent_cancelEventCreation', '');
        props.onCancel(input);
      }}
      onNavigate={(event) => {
        publishKatalMetric('createEvent_wizardPage', `${event.detail.requestedStepIndex}`);
        if (props.onNavigate) {
          props.onNavigate(event);
        }
      }}
      steps={props.steps}
      onSubmit={(input) => {
        publishKatalMetric('createEvent_submitEventCreation', '');
        props.onSubmit(input);
      }}
      activeStepIndex={props.activeStepIndex}
      secondaryActions={props.secondaryActions}
    />
  );
}
